import { render, staticRenderFns } from "./variables.component.vue?vue&type=template&id=372870a3&scoped=true&"
import script from "./variables.component.vue?vue&type=script&lang=js&"
export * from "./variables.component.vue?vue&type=script&lang=js&"
import style0 from "./variables.component.vue?vue&type=style&index=0&id=372870a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372870a3",
  null
  
)

export default component.exports